<template>
  <el-tag :type="stateType">{{ stateText }}</el-tag>
</template>
<script>
export default {
  props: {
    state: {},
  },
  computed: {
    stateType() {
      switch (this.state) {
        case 0:
          return "info";
        case 1:
        case 2:
        case 3:
        case 4:
          return "success";  
        case 5:
          return "warning";      
        case 5:
          return "danger";      
      }
      return "info";
    },
    stateText() {
            
      switch (this.state) {
        case 0:
          return "待付款";
        case 1:
          return "待发货";
        case 2:
          return "待收货";
        case 3:
          return "已收货";
        case 4:
          return "已完成";
        case 5:
          return "待售后";
        case 6:
          return "已取消";
      }
      return "无效状态";
    },
  },
  methods: {},
};
</script>
